import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

export const ACCESS_TOKEN_KEY = "access_token";
export const WS_ACCESS_TOKEN_KEY = "ws_access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
// Nuxt-совместимые ключи для localStorage (с префиксом auth.)
export const AUTH_TOKEN_PASSWORD_GRANT = "auth._token.password_grant";
export const AUTH_TOKEN_WS_PASSWORD_GRANT = "auth._token.ws_password_grant";
export const AUTH_REFRESH_TOKEN_PASSWORD_GRANT = "auth._refresh_token.password_grant";
export const AUTH_STRATEGY = "auth.strategy";

// Ключи для proctoring.js (БЕЗ префикса auth.)
export const TOKEN_PASSWORD_GRANT = "_token.password_grant";
export const TOKEN_WS_PASSWORD_GRANT = "_token.ws_password_grant";

/**
 * Приватный axios-клиент — работает с токеном и авто-refresh логикой
 */
const axiosPrivateClient: AxiosInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_BASE_URL}/api`,
  timeout: 300000,
  headers: { "Content-Type": "application/json" },
});

axiosPrivateClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token =
      typeof window !== "undefined"
        ? localStorage.getItem(ACCESS_TOKEN_KEY)
        : null;
    if (token) config.headers.Authorization = `Bearer ${token}`;

    // Если отправляем FormData, удаляем Content-Type - браузер сам установит правильный с boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosPrivateClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = localStorage.getItem(REFRESH_TOKEN_KEY);
      if (!refresh) return Promise.reject(error);

      try {
        const { data } = await axios.post(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/oauth/token`,
          {
            grant_type: "refresh_token",
            client_id: process.env.NEXT_PUBLIC_PASSPORT_PASSWORD_GRANT_ID,
            client_secret:
              process.env.NEXT_PUBLIC_PASSPORT_PASSWORD_GRANT_SECRET,
            refresh_token: refresh,
          }
        );

        localStorage.setItem(ACCESS_TOKEN_KEY, data.access_token);
        localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);

        // Nuxt-совместимые ключи
        localStorage.setItem(AUTH_TOKEN_PASSWORD_GRANT, `Bearer ${data.access_token}`);
        if (data.refresh_token) {
          localStorage.setItem(AUTH_REFRESH_TOKEN_PASSWORD_GRANT, data.refresh_token);
        }

        // storage event does NOT fire in the same tab
        if (typeof window !== "undefined") {
          window.dispatchEvent(new Event("auth-token-changed"));
        }

        original.headers.Authorization = `Bearer ${data.access_token}`;

        return axiosPrivateClient(original);
      } catch (err) {
        localStorage.clear();

        if (typeof window !== "undefined") {
          // notify same-tab listeners (Centrifugo auth bridge, etc.)
          window.dispatchEvent(new Event("auth-token-changed"));
          window.location.href = "/auth";
        }

        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosPrivateClient;
